import request from '@/utils/request'


// 查询用户积分变动记录列表
export function listLog(query) {
  return request({
    url: '/user/log/list',
    method: 'get',
    params: query
  })
}

// 查询用户积分变动记录分页
export function pageLog(query) {
  return request({
    url: '/user/bill/page',
    method: 'get',
    params: query
  })
}

// 投票记录
export function toupiaoLog(data) {
    return request({
    url: '/zb/huodong/toupiao/page',
    method: 'post',
    data: data
  })
}

// 集卡记录
export function jikajilu(data) {
  return request({
    url: '/zb/dianzi/jika/page',
    method: 'post',
    data: data
  })
}

export function addjikajilu(data) {
  return request({
    url: '/zb/dianzi/jika/add',
    method: 'post',
    data: data
  })
}

// 排行榜奖品记录
export function paihangbangjiangpin(data) {
  return request({
    url: '/zb/huodong/goods/user/page',
    method: 'post',
    data: data
  })
}

export function tihuo(data) {
  return request({
    url: '/zb/huodong/goods/user/tihuo',
    method: 'post',
    data: data
  })
}

// 删除活动奖品记录
export function delHuodongGoodsUser(data) {
  return request({
    url: '/zb/huodong/goods/user/delete',
    method: 'post',
    data: data
  })
}

export function manualOperateScore(data) {
  return request({
    url: '/user/bill/manualOperateScore',
    method: 'post',
    data: data
  })
}

// 活动明细
export function huodongmingxi(data) {
  return request({
    url: '/zb/huodong/sore/page',
    method: 'post',
    data: data
  })
}

// 修改活动积分
export function editHuodongSore(data) {
  return request({
    url: '/zb/huodong/sore/edit',
    method: 'post',
    data: data
  })
}

// 删除活动积分记录
export function delHuodongSore(data) {
  return request({
    url: '/zb/huodong/sore/delete',
    method: 'post',
    data: data
  })
}
// 活动统计
export function huodongtongji(data) {
  return request({
    url: '/zb/huodong/sore/tongji',
    method: 'post',
    data: data
  })
}



// 查询用户积分变动记录详细
export function getLog(data) {
  return request({
    url: '/user/log/detail',
    method: 'get',
    params: data
  })
}

// 新增用户积分变动记录
export function addLog(data) {
  return request({
    url: '/user/log/add',
    method: 'post',
    data: data
  })
}

// 修改用户积分变动记录
export function updateLog(data) {
  return request({
    url: '/user/log/edit',
    method: 'post',
    data: data
  })
}

// 删除用户积分变动记录
export function delLog(data) {
  return request({
    url: '/user/log/delete',
    method: 'post',
    data: data
  })
}
